import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserdataService } from './userdata.service';

import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private userdata: UserdataService,
    private ms: SnackService
  ) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      document.title = 'ideastream.io';
    } catch (error) { }


    return await new Promise<boolean>((resolve, reject) => {
      this.http.post(`${serverurl}/auth/checklogin`, {}).subscribe({
        next: async (data: any) => {
          const userData = await this.userdata.data.getValue();
          if (!userData && data) {
            this.userdata.data.next(data.userdata);
            // console.log('Data from Server', data.userdata);
          }

          if (userData?.status === 'CONFIRM') {
            this.ms.error({headline: "Confirmation Required", text:"You have to confirm your email."});
          }

          localStorage.setItem('ids_be_lastvisit', state.url);
          resolve(true);
        },
        error: (err: any) => {
          console.error('Fehler bei der Authentifizierung', err);
          sessionStorage.clear();
          this.userdata.data.next(null);
          this.router.navigate(['login']);
          if (err.status !== 403) console.log('error', err);
          reject(false);
        }
      });
    });
  }
}
